import dayjs from 'dayjs'
import { computed } from 'vue'

import EarningsCallsPreviewSummaryClass from '../libs/earnings_calls_preview_summary'

export default function useEarningsCallInfoData({
  date, epsReported, epsEstimate, epsReportedLastYear,
}) {
  const formattedDate = computed(() => dayjs(date.value).format('YY/MM/DD'))
  const epsEstimateMarketData = computed(
    () => EarningsCallsPreviewSummaryClass.getEpsEstimateMarketData({
      reported: epsReported.value,
      estimate: epsEstimate.value,
    }),
  )
  const epsYoYData = computed(
    () => EarningsCallsPreviewSummaryClass.getEpsYoYData({
      reported: epsReported.value,
      reportedLastYear: epsReportedLastYear.value,
    }),
  )
  const earningsCallsInfoList = computed(() => [
    {
      label: '公布時間',
      value: formattedDate.value,
      valueSuffix: '',
      additionalClass: '',
    },
    {
      label: '本季實際 EPS',
      value: `${epsReported.value || '-'}`,
      valueSuffix: epsReported.value ? '美元' : '',
      additionalClass: '',
    },
    {
      label: epsEstimateMarketData.value.label,
      value: epsEstimateMarketData.value.value,
      valueSuffix: epsEstimateMarketData.value.valueSuffix,
      additionalClass: epsEstimateMarketData.value.classname,
    },
    {
      label: epsYoYData.value.label,
      value: epsYoYData.value.value,
      valueSuffix: epsYoYData.value.valueSuffix,
      additionalClass: epsYoYData.value.classname,
    },
  ])

  return {
    formattedDate,
    epsEstimateMarketData,
    epsYoYData,

    earningsCallsInfoList,
  }
}
